import TotalDataComponent from "../../components/total-data.component";
import TableComponent from "../../components/table-component";
import {useDispatch, useSelector} from "react-redux";
import {
    setCommentModalVisibility,
    setCommentSelectedRowKeys
} from "../../reducers/comment.reducer";
import {convertDateToCustomFormat, getStarRatingImage} from "../../utils/general-variable";
import {ThreeDotsIcon, UserProfileDefault} from "../../utils/image"
import {setReviewData} from "../../reducers/review.reducer";
import React from "react";

const ReviewsList = ({dataSource, isLoading}) => {
    const dispatch = useDispatch()
    const {selectedRowKeysComment} = useSelector(state => state.commentReducer)
    const columns = [
        {
            type: 'checkbox',
            classNameHeader: 'px-3',
        }, {
            name: 'Nama',
            classNameHeader: 'pl-5',
            width: 300,
            render: (record) => (
                <div className={"row items-center space-x-3 pl-5"}>
                    <img src={record.image_url || UserProfileDefault} className={"w-10 h-10 rounded-lg"} alt={"imageUser"}/>
                    <div className={"col space-y-1 font-regular"}>
                        <p className={"text-monstera capitalize"}>{record.fullname}</p>
                        <p className={"text-forged-steel"}>{record.email}</p>
                    </div>
                </div>
            )
        }, {
            name: 'Nama Produk',
            dataIndex: 'name',
            width: 250
        }, {
            name: 'Rating',
            dataIndex: 'rate',
            classNameHeader: 'text-center',
            render: (rate) => (
                <div className={"row space-x-1 justify-center"}>
                    {getStarRatingImage(rate).map((starImage, index) => (
                        <img key={index} src={starImage}
                             alt="starRating" className={"w-3"}/>
                    ))}
                </div>
            )
        }, {
            name: 'Comment',
            width: 275,
            classNameHeader: 'text-center',
            render: (record) => (
                <div className={"row items-center justify-center space-x-3 py-4 text-forged-steel"}>
                    <div className={"line-clamp-3 w-5/6"}>
                        <div dangerouslySetInnerHTML={{__html: record.review}} />
                    </div>
                    <div className={"rounded-full bg-battleship-green hover:bg-monstera w-fit"}>
                        <img src={ThreeDotsIcon} alt="buttonCommentDetail"
                             className={"w-5 cursor-pointer"} onClick={() => showCommentDetail(record)}/>
                    </div>
                </div>
            )
        }, {
            name: 'Created At',
            dataIndex: 'created_at',
            classNameHeader: 'text-center pl-3',
            render: (created_at) => (
                <div className={"text-center text-forged-steel pl-3"}>
                    <p>{convertDateToCustomFormat(created_at, 'YYYY/MM/DD HH:mm')}</p>
                </div>
            )
        }
    ]

    const onChangeSelectedRowKeys = (array) => {
        dispatch(setCommentSelectedRowKeys(array))
    }

    const showCommentDetail = (data) => {
        dispatch(setReviewData(data))
        dispatch(setCommentModalVisibility({commentDetail: true}))
    }

    return (
        <div className={"col space-y-4"}>
            <TotalDataComponent subject={"Comments"}/>
            <TableComponent
                columns={columns}
                tableClassName={"font-Regular"}
                headerClassName={"bg-windmill-wings font-semibold text-left text-monstera h-8"}
                selectedRowKeys={selectedRowKeysComment}
                onChangeSelectedRowKeys={onChangeSelectedRowKeys}
                dataSource={dataSource}
                pagination={true}
                loading={isLoading}
            />
        </div>
    )
}

export default ReviewsList
